<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'newgoodsrecordForm',
		props: {

		},
		data() {
			return {

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			afterBoxSubmit(e) {
				if (e.moduleName == 'newgoodsapproval') {
					this.fApi.setValue('newgoodsapproval_time',e.data.commit_time * 1000)
				}
			},
		},
		components: {

		}
	}
</script>
